import { applyPathFilter as applyPathFilterDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

export type Props = ApiMethodBase & {
    predicate?: any,
    constraint_type?: any,
    duration_operator?: any, 
    actual_from?: any, 
    actual_to?: any, 
    value?: any, 
    mode?: any
}

export async function applyPathFilter ({
    predicate,
    constraint_type,
    duration_operator, 
    actual_from, 
    actual_to, 
    value, 
    mode,
    eventEmitter,
}: Props) {
    applyPathFilterDiagram({
        predicate: predicate,
        constraint_type: constraint_type,
        duration_operator: duration_operator, 
        actual_from: actual_from, 
        actual_to: actual_to, 
        value: value, 
        mode: mode.mode
     });
    eventEmitter.emit(Event.applyFilter);
    apiProvider.setDiagramVisualizer()    
    eventEmitter.emit(Event.updateGaugeMetrics);
};

